import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Modal              from 'app/components/common/modal';
import ViewAdvanced       from 'app/components/company-admin/employees/modal-edit-cattrs/view-advanced';
import ViewSimple         from 'app/components/company-admin/employees/modal-edit-cattrs/view-simple';
import ViewTest           from 'app/components/company-admin/employees/modal-edit-cattrs/view-test';
import CavsDuck           from 'app/ducks/company-admin/cattr-vals';
import CadminSlx          from 'app/selectors/company-admin/';

const viewOpts = [
  {label: 'Standard', value: 'simple', noHighlight: true},
  {label: 'Advanced', value: 'advanced', noHighlight: true},
  {label: 'Timeline', value: 'test', noHighlight: true},
];

class ModalEditEmployeeCattrs extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      view: 'simple',
    };

    this.onChangeView = this.onChangeView.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  get viewLabel() {
    const opt = viewOpts.find(vo => vo.value === this.state.view);
    return opt.label;
  }

  componentDidMount() {
    this.props.setEmp();
  }

  onChangeView(view) {
    this.setState({view});
  }

  onClickView(view, event) {
    event.preventDefault();
    this.setState({view});
  }

  onClose() {
    this.props.onClose();
  }

  renderView() {
    const commonProps = {
      company: this.props.company,
      employee: this.props.employee,
      companyCattrs: this.props.companyCattrs,
      onClose: this.onClose,
      company: this.props.company,
    };
    const {view} = this.state;
    if (view === 'test') return <ViewTest {...commonProps} />;
    if (view === 'advanced') return <ViewAdvanced {...commonProps} />;
    return <ViewSimple {...commonProps} />;
  }

  render() {
    const {employee} = this.props;
    return (
      <Modal className={`modal-emp-cattrs bform view-${this.state.view}`} onClose={this.onClose}>
        <div className="bform-head">
          <div className="bform-head-left">
            <div className="bform-head-breadcrumb">{`${employee.firstName} ${employee.lastName} • ${employee.email}`}</div>
            <h1 className="bform-h1">Edit Custom Attributes</h1>
          </div>
          <div className="bform-head-right modal-emp-cattrs-controls">
            <span className="modal-emp-cattrs-controls-label">{`${this.viewLabel} View`}</span>
            <EllipsisMenu icon={<Icon.Cog1 />}>
              {viewOpts.map((viewOpt) => {
                return <a key={viewOpt.value} href="#" onClick={this.onClickView.bind(this, viewOpt.value)}>{`${viewOpt.label}`}</a>;
              })}
            </EllipsisMenu>
          </div>
        </div>
        {this.renderView()}
      </Modal>
    );
  }

}

ModalEditEmployeeCattrs.propTypes = {
  onClose: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
};

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  companyCattrs: CadminSlx.selectableCattrs(state),
});

const dispatchToProps = (dispatch, ownProps) => ({
  setEmp: () => dispatch(CavsDuck.Ax.setEmployee(ownProps.employee.id)),
});

export default connect(stateToProps, dispatchToProps)(ModalEditEmployeeCattrs);
